import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DeviceConfig } from '../../models/device-config';
import { ApiResponse } from '../../models/api-response';

@Injectable({
  providedIn: 'root'
})
export class DeviceConfigService {
  private readonly baseUrl = `${environment.vibrationApiURL}/device`;

  constructor(private http: HttpClient) {}

  /**
   * Get full device configuration by serial number
   * @param deviceSerialNumber Device serial number
   * @returns Observable with device configuration
   */
    getDeviceConfiguration(
      deviceSerialNumber: string | null,
      siteId: number | null
    ): Observable<DeviceConfig> {

      let params = new HttpParams();

      if (deviceSerialNumber) {
        params = params.set('deviceSerialNumber', deviceSerialNumber);
      }

      if (siteId !== null) {
        params = params.set('siteId', siteId.toString());
      }

      return this.http.get<DeviceConfig>(`${this.baseUrl}/full-config`, { params });
    }

  /**
   * Update full device configuration by serial number
   * @param deviceSerialNumber Device serial number
   * @param deviceConfigDto Device configuration data to update
   * @returns Observable with API response containing updated configuration
   */
  updateDeviceConfiguration(
    deviceConfigDto: DeviceConfig
  ): Observable<ApiResponse<DeviceConfig>> {
    return this.http.post<ApiResponse<DeviceConfig>>(
      `${this.baseUrl}/full-config`, 
      deviceConfigDto
    );
  }
}